module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_3_m2.e2c255b66596639d8748ecf3df60154f.png";